import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { StatesComponent } from "./states.component";

const statesRoutes: Routes = [
  { path: "", component: StatesComponent , data:{title: 'States'} },
];

@NgModule({
  imports:[
    RouterModule.forChild(statesRoutes)
  ],
  exports:[
    RouterModule
  ]

})
export class StatesRoutingModule {}







// WEBPACK FOOTER //
// ./src/app/t6-states/states-routing.module.ts